import React from 'react';
import { Box } from 'src/components/Box';
import { Dialog } from 'src/components/Dialog';
import { Typography } from 'src/components/Typography';
import { Video } from 'src/components/Video';
import { Video as VideoType } from 'src/models/video/_types';

interface VideoDialogProps {
  open: boolean;
  video: VideoType | null;
  onClose: () => void;
}

export const VideoDialog: React.FC<VideoDialogProps> = ({
  open,
  video,
  onClose,
}) => {
  const actions = [
    {
      label: 'Close',
      onClick: onClose,
      variant: 'outlined' as const,
    },
  ];

  if (!video) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={video.name}
      maxWidth="md"
      fullWidth
      actions={actions}
    >
      <Box sx={{ mb: 2 }}>
        <Video videoUrl={video.embedUrl} />
      </Box>
      {video.description && (
        <Typography variant="body2" sx={{ mb: 2 }}>
          {video.description}
        </Typography>
      )}
    </Dialog>
  );
};
